import { QueryClient } from "@tanstack/react-query";

// QueryClient ตัวกลางของแอป
// แยกออกมาเป็นไฟล์ของตัวเอง เพื่อให้ redux action (ที่ไม่ใช่ component)
// เรียก invalidateQueries ได้ โดยไม่ต้อง import จาก index.tsx ซึ่งจะเกิด import วน
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 นาที - ข้อมูลจะถือว่า "fresh" เป็นเวลา 5 นาที
      gcTime: 10 * 60 * 1000, // 10 นาที - เก็บ cache ไว้ 10 นาที (เดิมชื่อ cacheTime)
      refetchOnWindowFocus: false, // ไม่ refetch เมื่อ focus กลับมาที่หน้าต่าง
      retry: 1, // retry 1 ครั้งถ้า fail
    },
  },
});

/** ล้าง cache รายชื่อเด็กทุก query (queryKey ขึ้นต้นด้วย "children") */
export const invalidateChildQueries = () => {
  queryClient.invalidateQueries({ queryKey: ["children"] });
};

export default queryClient;
